/* eslint-disable max-len */
/* eslint-disable max-len */
import React from 'react'

/*
  sizes:
  ---------
  s:  16x16
  m:  24x24
  l:  32x32
  xl: 48x48
*/

export const Annulment = (props) => {
  const { size, svgClass, pathClass, customWidth, customHeight } = props

  switch (size) {
    // Este icono es muy grande en tamaños normales por lo que se establece un menor tamaño para versiones más grandes.
    case 'xl':
      return (
        <svg
          className={`icon-component ${svgClass}`}
          width={customWidth || 48}
          height={customHeight || 48}
          viewBox='0 0 48 48'
          version='1.1'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'>
          <g
            id='Page-1'
            stroke='none'
            strokeWidth='1'
            fill='none'
            fillRule='evenodd'
            strokeLinecap='round'
            strokeLinejoin='round'>
            <g
              id='FDC_070624_01'
              transform='translate(-756, -521)'
              stroke='#000000'>
              <g id='Group-7' transform='translate(148, 104)'>
                <g id='Group-10' transform='translate(144, 209.5)'>
                  <g id='Group-2' transform='translate(0, 184)'>
                    <g id='Group-14' transform='translate(440, 0)'>
                      <g id='Group-4' transform='translate(24, 24)'>
                        <g id='Group-18' transform='translate(4, 4)'>
                          <g
                            id='x'
                            transform='translate(16, 16)'
                            strokeWidth='2'>
                            <line
                              x1='8'
                              y1='0'
                              x2='0'
                              y2='8'
                              id='Path'
                              className={pathClass}
                            />
                            <line
                              x1='0'
                              y1='0'
                              x2='8'
                              y2='8'
                              id='Path'
                              className={pathClass}
                            />
                          </g>
                          <g id='circle-2' strokeWidth='3'>
                            <g id='circle'>
                              <circle
                                id='Oval'
                                cx='20'
                                cy='20'
                                r='20'
                                className={pathClass}
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      )
    case 'l':
      return (
        <svg
          className={`icon-component ${svgClass}`}
          width={customWidth || 32}
          height={customHeight || 32}
          viewBox='0 0 48 48'
          version='1.1'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'>
          <g
            id='Page-1'
            stroke='none'
            strokeWidth='1'
            fill='none'
            fillRule='evenodd'
            strokeLinecap='round'
            strokeLinejoin='round'>
            <g
              id='FDC_070624_01'
              transform='translate(-756, -521)'
              stroke='#000000'>
              <g id='Group-7' transform='translate(148, 104)'>
                <g id='Group-10' transform='translate(144, 209.5)'>
                  <g id='Group-2' transform='translate(0, 184)'>
                    <g id='Group-14' transform='translate(440, 0)'>
                      <g id='Group-4' transform='translate(24, 24)'>
                        <g id='Group-18' transform='translate(4, 4)'>
                          <g
                            id='x'
                            transform='translate(16, 16)'
                            strokeWidth='2'>
                            <line
                              x1='8'
                              y1='0'
                              x2='0'
                              y2='8'
                              id='Path'
                              className={pathClass}
                            />
                            <line
                              x1='0'
                              y1='0'
                              x2='8'
                              y2='8'
                              id='Path'
                              className={pathClass}
                            />
                          </g>
                          <g id='circle-2' strokeWidth='3'>
                            <g id='circle'>
                              <circle
                                id='Oval'
                                cx='20'
                                cy='20'
                                r='20'
                                className={pathClass}
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      )
    case 'm':
      return (
        <svg
          className={`icon-component ${svgClass}`}
          width={customWidth || 24}
          height={customHeight || 24}
          viewBox='0 0 48 48'
          version='1.1'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'>
          <g
            id='Page-1'
            stroke='none'
            strokeWidth='1'
            fill='none'
            fillRule='evenodd'
            strokeLinecap='round'
            strokeLinejoin='round'>
            <g
              id='FDC_070624_01'
              transform='translate(-756, -521)'
              stroke='#000000'>
              <g id='Group-7' transform='translate(148, 104)'>
                <g id='Group-10' transform='translate(144, 209.5)'>
                  <g id='Group-2' transform='translate(0, 184)'>
                    <g id='Group-14' transform='translate(440, 0)'>
                      <g id='Group-4' transform='translate(24, 24)'>
                        <g id='Group-18' transform='translate(4, 4)'>
                          <g
                            id='x'
                            transform='translate(16, 16)'
                            strokeWidth='2'>
                            <line
                              x1='8'
                              y1='0'
                              x2='0'
                              y2='8'
                              id='Path'
                              className={pathClass}
                            />
                            <line
                              x1='0'
                              y1='0'
                              x2='8'
                              y2='8'
                              id='Path'
                              className={pathClass}
                            />
                          </g>
                          <g id='circle-2' strokeWidth='3'>
                            <g id='circle'>
                              <circle
                                id='Oval'
                                cx='20'
                                cy='20'
                                r='20'
                                className={pathClass}
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      )
    case 's':
      return (
        <svg
          className={`icon-component ${svgClass}`}
          width={customWidth || 16}
          height={customHeight || 16}
          viewBox='0 0 48 48'
          version='1.1'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'>
          <g
            id='Page-1'
            stroke='none'
            strokeWidth='1'
            fill='none'
            fillRule='evenodd'
            strokeLinecap='round'
            strokeLinejoin='round'>
            <g
              id='FDC_070624_01'
              transform='translate(-756, -521)'
              stroke='#000000'>
              <g id='Group-7' transform='translate(148, 104)'>
                <g id='Group-10' transform='translate(144, 209.5)'>
                  <g id='Group-2' transform='translate(0, 184)'>
                    <g id='Group-14' transform='translate(440, 0)'>
                      <g id='Group-4' transform='translate(24, 24)'>
                        <g id='Group-18' transform='translate(4, 4)'>
                          <g
                            id='x'
                            transform='translate(16, 16)'
                            strokeWidth='2'>
                            <line
                              x1='8'
                              y1='0'
                              x2='0'
                              y2='8'
                              id='Path'
                              className={pathClass}
                            />
                            <line
                              x1='0'
                              y1='0'
                              x2='8'
                              y2='8'
                              id='Path'
                              className={pathClass}
                            />
                          </g>
                          <g id='circle-2' strokeWidth='3'>
                            <g id='circle'>
                              <circle
                                id='Oval'
                                cx='20'
                                cy='20'
                                r='20'
                                className={pathClass}
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      )
    default:
      // size: m
      return (
        <svg
          className={`icon-component ${svgClass}`}
          width={customWidth || 16}
          height={customHeight || 16}
          viewBox='0 0 48 48'
          version='1.1'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'>
          <g
            id='Page-1'
            stroke='none'
            strokeWidth='1'
            fill='none'
            fillRule='evenodd'
            strokeLinecap='round'
            strokeLinejoin='round'>
            <g
              id='FDC_070624_01'
              transform='translate(-756, -521)'
              stroke='#000000'>
              <g id='Group-7' transform='translate(148, 104)'>
                <g id='Group-10' transform='translate(144, 209.5)'>
                  <g id='Group-2' transform='translate(0, 184)'>
                    <g id='Group-14' transform='translate(440, 0)'>
                      <g id='Group-4' transform='translate(24, 24)'>
                        <g id='Group-18' transform='translate(4, 4)'>
                          <g
                            id='x'
                            transform='translate(16, 16)'
                            strokeWidth='2'>
                            <line
                              x1='8'
                              y1='0'
                              x2='0'
                              y2='8'
                              id='Path'
                              className={pathClass}
                            />
                            <line
                              x1='0'
                              y1='0'
                              x2='8'
                              y2='8'
                              id='Path'
                              className={pathClass}
                            />
                          </g>
                          <g id='circle-2' strokeWidth='3'>
                            <g id='circle'>
                              <circle
                                id='Oval'
                                cx='20'
                                cy='20'
                                r='20'
                                className={pathClass}
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      )
  }
}
